import { render, staticRenderFns } from "./RegistrationSelection.vue?vue&type=template&id=be6274d6"
import script from "./RegistrationSelection.vue?vue&type=script&lang=js"
export * from "./RegistrationSelection.vue?vue&type=script&lang=js"
import style0 from "./RegistrationSelection.vue?vue&type=style&index=0&id=be6274d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports